module.exports = __webpack_public_path__ + "media/img/iphone_app_new@2x-3cd66b1f.png";